import { Point } from "./Point";
import { IGeometry } from "./IGeometry";

/**
 * Represents a 2D LineSegment geometry
 */
export class LineSegment implements IGeometry {
  start: Point;
  end: Point;

  constructor(start: Point, end: Point) {
    this.start = start;
    this.end = end;
  }

  toOrdinates(): number[] {
    return [this.start.x, this.start.y, this.end.x, this.end.y];
  }

  center(): Point {
    return new Point((this.start.x + this.end.x) / 2, (this.start.y + this.end.y) / 2);
  }
}
